import http from '@/plugins/http';

export default (params) => new Promise((res, rej) => {
  http.put('/v3/users/auth0/attach_account_request', { email: params.email, token: params.token })
    .then((response) => {
      res(response.data);
    }, (response) => {
      rej(response);
    });
});
